// extracted by mini-css-extract-plugin
module.exports = {"title":"style_title__1eB9I","line":"style_line__2vV6b"};